export const SideBarElements = [
  { name: "Home", id: "home", completed: true },
  { name: "About", id: "about", completed: true },
  { name: "Projects", id: "projects", completed: true },
  { name: "Services", id: "services", completed: true },
  { name: "Testimonials", id: "testimonials", completed: true },
  { name: "Contact", id: "contact", completed: true },
  { name: "Hire me", id: "hireme", different: true, completed: false },
];
